// extracted by mini-css-extract-plugin
export default {"wrapper":"Dm-z","response":"Em-z","error":"Fm-z","disabled":"Gm-z","buttons":"Hm-z","feedbackQuestionSection":"Im-z","yesNoWrapper":"Jm-z"};